import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate, useSearchParams } from 'react-router-dom';

const categories = [
  { path: '/', label: 'Home' },
  { path: '/sports', label: 'Sports' },
  { path: '/science', label: 'Science' },
  { path: '/entertainment', label: 'Entertainment' },
  { path: '/health', label: 'Health' },
  { path: '/technology', label: 'Technology' },
];

const maxQueryLength = 200;

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryFromUrl = searchParams.get('q') || '';
  const [query, setQuery] = useState(queryFromUrl.slice(0, maxQueryLength));
  const [isNavOpen, setIsNavOpen] = useState(false);

  useEffect(() => {
    setQuery(queryFromUrl.slice(0, maxQueryLength));
    setIsNavOpen(false);
  }, [location.key, location.pathname, location.search, queryFromUrl]);

  const closeNavigation = () => setIsNavOpen(false);

  const updateSearch = (nextQuery, replace = false) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete('q');
    if (nextQuery) {
      nextParams.set('q', nextQuery);
    }
    const nextSearch = nextParams.toString();
    navigate({
      pathname: location.pathname,
      search: nextSearch ? `?${nextSearch}` : '',
      hash: location.hash,
    }, { replace });
    closeNavigation();
  };

  const handleSearchChange = (event) => {
    const nextQuery = event.target.value.slice(0, maxQueryLength);
    setQuery(nextQuery);
    if (!nextQuery && searchParams.has('q')) {
      updateSearch('', true);
    }
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const nextQuery = query.trim().slice(0, maxQueryLength);
    setQuery(nextQuery);
    updateSearch(nextQuery);
  };

  return (
    <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-dark news-navbar" aria-label="Main navigation">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/" onClick={closeNavigation}>News-Today</Link>
        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarSupportedContent"
          aria-expanded={isNavOpen}
          aria-label="Toggle navigation"
          onClick={() => setIsNavOpen((isOpen) => !isOpen)}
        >
          <span className="navbar-toggler-icon" aria-hidden="true"></span>
        </button>
        <div className={`collapse navbar-collapse${isNavOpen ? ' show' : ''}`} id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {categories.map(({ path, label }) => (
              <li className="nav-item" key={path}>
                <NavLink
                  className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
                  to={path}
                  end
                  onClick={closeNavigation}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
          <form className="d-flex news-search" role="search" onSubmit={handleSearchSubmit}>
            <input
              className="form-control"
              type="search"
              placeholder="Search news"
              aria-label="Search news in the current category"
              maxLength={maxQueryLength}
              value={query}
              onChange={handleSearchChange}
            />
            <button className="btn btn-outline-success" type="submit">Search</button>
          </form>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
